import PropTypes from 'prop-types';

import Link from '@zenbusiness/zui/Link';

const DEFAULT_TARGET = '_blank';

const SmartLink = ({ children, clickstreamProps = {}, target, url = '', ...delegated }) => {
  const isExternal = target === DEFAULT_TARGET || url.startsWith('http');
  if (isExternal) {
    const finalTarget = isExternal && !target ? DEFAULT_TARGET : target;
    const rel = finalTarget === DEFAULT_TARGET ? 'noopener noreferrer' : undefined;

    return (
      <Link clickstreamProps={clickstreamProps} href={url} rel={rel} target={finalTarget} {...delegated}>
        {children}
      </Link>
    );
  }

  return (
    <Link to={url} clickstreamProps={clickstreamProps} {...delegated}>
      {children}
    </Link>
  );
};

SmartLink.propTypes = {
  children: PropTypes.node,
  clickstreamProps: PropTypes.shape({}),
  target: PropTypes.string,
  url: PropTypes.string,
};

export default SmartLink;
